import networkCallWrapper from "hooks/networking/networkCallWrapper";
import { getPlatform } from "utils/platforms";

export async function initBankAddition(): Promise<boolean> {

    const url = "client_user/bank_account/add/initiate"
    const method = "POST"
    const service = "userCaas"

    const platform = getPlatform().toString()
    const deviceId = platform + "-user"

    const request = await networkCallWrapper(
        url,
        method,
        service,
        null,
        {},
        undefined,
        {
            'X-Platform': platform,
            'X-Device-Id': deviceId,
            'X-Source': 'sdk',
        }
    );

    return request.success
}